import React from "react";
import { Box, Toolbar } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import AdminV2Header from "./AdminV2Header";
import styles from "./AdminV2Layout.module.scss";

const AdminV2Layout: React.FC = () => {
  const location = useLocation();

  return (
    <Box className={styles.layout}>
      <AdminV2Header />
      <Toolbar />
      <main className={styles.main}>
        <Outlet key={location.pathname} />
      </main>
    </Box>
  );
};

export default AdminV2Layout;
